var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        { "landing-page": _vm.$route.path === "/landing" },
        { gop: _vm.$route.path.startsWith("/gop/") },
        { "blue-bg": _vm.$route.meta.backgroundColor === "blue" },
        { "white-bg": _vm.$route.meta.backgroundColor === "white" }
      ],
      attrs: { id: "app" }
    },
    [
      _c("UnauthorizedUserPopup"),
      !_vm.isLoginPage &&
      _vm.$router.name !== "reset-password" &&
      _vm.$route.path !== "/landing"
        ? _c("Header")
        : _vm._e(),
      _vm.$route.path === "/landing" ? _c("LandingHeader") : _vm._e(),
      _vm.$store.getters.getLoading && !_vm.isLoginPage
        ? _c("ProgressBar")
        : _vm._e(),
      _c("Loading"),
      _c("ConfirmationPopup"),
      _c("GenericPopup"),
      _vm.isLoginPage && !_vm.localStorage.getItem("attemptedLoginWith")
        ? _c("InitialAnimation")
        : _vm._e(),
      _c(
        "div",
        {
          class: [
            { "gop-content-container": _vm.$route.path.includes("/gop/") },
            "content-container",
            {
              "redesign-gop-content-container": _vm.$route.path.includes(
                "/gop/"
              )
            }
          ]
        },
        [
          _vm.showSidebarOrFooter ? _c("SideMenu") : _vm._e(),
          _vm.showSidebarOrFooter
            ? _c("Transition", [
                _vm.sideMenuOpened
                  ? _c("div", {
                      staticClass: "content-cover",
                      on: { click: _vm.closeSideMenu }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          !_vm.isLoading
            ? _c(
                "div",
                {
                  ref: "mainContent",
                  class: [
                    "main-content",
                    {
                      "main-content-login":
                        _vm.isLoginPage || _vm.$router.name === "reset-password"
                    }
                  ],
                  attrs: { id: "mainContent" }
                },
                [
                  _c("router-view", {
                    key: _vm.$route.name,
                    staticClass: "page-enter-smooth"
                  }),
                  _c("Notification"),
                  _c("GopNotification"),
                  _c("GlobalSearchInput"),
                  _c("BackToTop"),
                  _c("Survey")
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.canShowCrudSideMenu
        ? _c("CrudSideMenu", {
            attrs: {
              crudSideMenuData: _vm.crudSideMenuData,
              "is-active": _vm.crudSideMenuStatus
            }
          })
        : _vm._e(),
      _c("Transition", [
        _vm.crudSideMenuStatus
          ? _c("div", { staticClass: "crud-sidemenu-cover" })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }